export const operatorLabel = (quantifier, isHas, t)=>{
    const isNone = quantifier === 'none';
    if (isHas) return isNone ? t.servicesOperatorHasNo() : t.servicesOperatorHas();
    return isNone ? t.servicesOperatorIsNot() : t.servicesOperatorIs();
};
